export default {
      id: "star-usage",
      viewBox: "0 0 15 15",
      url: "../../assets/" + "sprite.svg#star-usage",
      toString: function () {
        return this.url;
      }
    }